import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { AssessmentForm } from "../../components/assessmentForm";
import {
  AssessmentLayout,
  Footer,
} from "../../../shared/components/AssessmentLayout";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    alignItems: "stretch",
    justifyContent: "space-between",
    minHeight: "100vh",
    background: `url("/mentoro-icon-background.svg") repeat center center fixed;`,
  },
  container: {
    width: "100%",
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
}));

export const AssessmentPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <AssessmentLayout>
          <AssessmentForm />
        </AssessmentLayout>
      </div>
      <Footer />
    </div>
  );
};
